(function () {
  function getHeaderHeight() {
    var sel = window.innerWidth > 1024 ? 'sticky-header' : 'sticky-header-mobile';
    var h = document.querySelector(sel);
    return h ? h.getBoundingClientRect().height : 80;
  }

  function scrollToCadastro() {
    var target =
      document.querySelector('[id$="__como_participar"]') ||
      document.querySelector('[id$="__form_participar"]') ||
      document.getElementById('shopify-section-como_participar') ||
      document.getElementById('shopify-section-form_participar');
    if (!target) return;
    var y = target.offsetTop - getHeaderHeight() - 20;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#cadastro"]');
    if (!a) return;
    e.preventDefault();
    scrollToCadastro();
    history.replaceState(null, '', '#cadastro');
  });

  if (location.hash === '#cadastro') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(scrollToCadastro, 400);
      });
    } else {
      setTimeout(scrollToCadastro, 400);
    }
  }
})();
